import React from 'react';
import cardUtils from '../../utils/cardUtils';
import AddToCartButton from '../shoppingCart/AddToCartButton';
import RemoveFromCartButton from '../shoppingCart/RemoveFromCartButton';
import formatter from '../../utils/formatter';
import Button from '../common/Button';
import apiHelper from '../../utils/apiHelpers';

const CardPrice = props => {
  const priceProvider = apiHelper.getPriceProvider();
  const priceProviderLabel = priceProvider === 'cardkingdom' ? 'CK' : 'TCG';

  return (
    <div className="flex flex-col gap-y-2 bg-lightColor rounded-md p-4">
      <span>
        <span className="font-bold">Tienda:</span> {props.price.store}
      </span>
      <span>
        <span className="font-bold">Precio:</span>{' '}
        {cardUtils.calculatePrice(props.price)}
        <i
          className={`fas fa-circle ml-2 ${cardUtils.comparePrice(
            props.price,
          )}`}></i>
      </span>
      <span>
        <span className="font-bold">Stock:</span> {props.price.stock}
      </span>
      <span>
        <span className="font-bold">Condición:</span> {props.price.condition}
      </span>
      <span>
        <span className="font-bold">Edición:</span> {props.price.edition}
      </span>
      <span>
        <span className="font-bold">Idioma:</span>{' '}
        {formatter.formatLanguage(props.price.language)}
      </span>
      {props.price.standardPriceTCGPlayer !== undefined &&
        props.price.standardPriceTCGPlayer !== 0 && (
          <span>
            <span className="font-bold">
              Precio ref. ({priceProviderLabel}):
            </span>{' '}
            {formatter.formatNumber(props.price.standardPriceTCGPlayer)} USD
          </span>
        )}
      <a href={props.price.storeUrl} target="_blank" rel="noopener noreferrer">
        <Button className="w-full" iconClass="fas fa-shopping-basket">
          Ver en tienda
        </Button>
      </a>
      {props.addToCart && (
        <AddToCartButton
          card={props.card}
          price={props.price}></AddToCartButton>
      )}
      {props.removeFromCart && (
        <RemoveFromCartButton
          card={props.card}
          price={props.price}
          onRemoveCardFromCart={props.removeFromCart}></RemoveFromCartButton>
      )}
    </div>
  );
};

export default CardPrice;
